import { uniq } from "lodash";

import { IGraphoopperPath } from "types";
import { BOUNDING_BOXES } from "constants/locations";

import { getCountryISO2 } from "../helpers";

export const crossedInRoute = (
  countries: IGraphoopperPath["details"]["country"]
) => {
  const iso3Codes = uniq(countries.map((i) => i[2])).filter(
    Boolean
  ) as string[];
  const iso2Codes = iso3Codes.map(getCountryISO2).filter(Boolean) as string[];
  const names = iso2Codes.map(
    (code) => BOUNDING_BOXES.find((item) => item.code === code)?.name ?? "-/-"
  );

  return { iso2Codes, iso3Codes, names };
};
